import React, { Component } from 'react';
import { recover } from '../../lib/api';
import { Redirect, Link } from "react-router-dom";


class Recover extends Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                email: ""
            },
            sent: false,
            loading: false,
            error: false
        };

        this.onFormChange = this.onFormChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormChange(event) {
        const name = event.target.name;
        const value = event.target.value;

        this.setState(prevState => {
            return {
                form: {
                    ...prevState.form,
                    [name]: value
                },
                error: false
            };
        });
    }

    onFormSubmit(event) {
        event.preventDefault();

        this.setState({
            loading: true
        });

        recover.request(this.state.form)
            .then(() => {
                this.setState({
                    sent: true,
                    loading: false
                });
            })
            .catch(error => {
                this.setState({
                    error: true,
                    loading: false
                });
            });
    }

    render() {
        const errorClass = this.state.error ? "is-danger" : "";

        if (this.props.user) {
            return (
                <Redirect to={{ pathname: "/after-sign-in" }} />
            );
        }

        return (
            <section id="recuperar" className="section is-fullscreen is-flex is-justify-content-center is-align-items-center">
                <div className="box p-5 has-background-white-bis" style={{maxWidth: '400px'}}>
                    <h1 className="title has-text-primary has-text-centered mb-5">Recuperar palavra-passe</h1>

                    {this.state.sent ? (
                        <div className="notification is-success is-light">
                            Se o email estiver registado, receberá em breve um link para redefinir a palavra-passe.
                        </div>
                    ) : (
                        <form name="recover" method="POST" onSubmit={this.onFormSubmit}>
                            <p className="mb-4">Indique o email da sua conta e enviaremos um link para redefinir a palavra-passe.</p>
                            <div className="field">
                                <p className="control has-icons-left">
                                    <input className={"input " + errorClass} name="email" type="email" required
                                           placeholder="E-mail" value={this.state.form.email}
                                           onChange={this.onFormChange}/>
                                    <span className="icon is-small is-left">
                                        <i className="fas fa-envelope"></i>
                                    </span>
                                </p>
                                {this.state.error && (
                                    <p className="help is-danger">Ocorreu um erro. Por favor tente novamente.</p>
                                )}
                            </div>
                            <div className="field">
                                <p className="control">
                                    <button type="submit" className={`button is-primary is-fullwidth ${this.state.loading ? "is-loading" : ""}`} disabled={this.state.loading}>Enviar link</button>
                                </p>
                            </div>
                        </form>
                    )}

                    <p className="has-text-centered mt-3">
                        <Link to="/entrar">Voltar a entrar</Link>
                    </p>
                </div>
            </section>
        );
    }
}

export default Recover;
